<template>
  <v-container>
    <hr>
    <p class="text-center">
      <RouterLink :to="{ name: 'BeforeYouStart' }">
        Before you start
      </RouterLink>
      |
      <RouterLink :to="{ name: 'DataProtection' }">
        Data Protection
      </RouterLink>
      |
      <RouterLink :to="{ name: 'AdminHome' }">
        Login
      </RouterLink>
      |
      Environment: <b>{{ environment }}</b>
    </p>
  </v-container>
</template>

<script>
import config from '@/config'

export default {
  name: 'FooterLinks',
  data () {
    return { environment: config.environment }
  }
}
</script>

<style scoped>
.text-center { text-align: center; }
</style>
